import { lazy, useMemo } from 'react';
import { mapMmCombinedSortByToSortBy } from 'src/apis/iip-service/mappings';
import type { MmsParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useMms } from 'src/apis/iip-service/use-mms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useMmPageParams } from 'src/pages/market-messages/maintenance-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const MaintenanceMessagesOverview = ({ iipService }: Props) => {
  const params = useMmPageParams();

  const transformedParams = useMemo(() => {
    const { start, pageSize, operatorId, sortBy, ...rest } = params.value;
    return {
      offset: start,
      limit: pageSize,
      operatorId: operatorId.map((item) => item.value),
      ...mapMmCombinedSortByToSortBy(sortBy),
      ...rest,
    } satisfies MmsParams;
  }, [params.value]);

  const mms = useMms({ iipService, params: transformedParams });

  if (!mms.response) return <PageSpinner />;

  return <Page mms={mms} iipService={iipService} pageParams={params} />;
};
